import React, { useState } from 'react';
import { getAuth, signInWithEmailAndPassword } from 'firebase/auth';
import { getFirestore, doc, getDoc ,setDoc } from 'firebase/firestore';
import { initializeApp } from 'firebase/app';
import { useNavigate } from 'react-router-dom';

const firebaseConfig = {
  apiKey: "AIzaSyDJ_lusSO40qPa2pKdvwOOexRPU2p4Vsro",
  authDomain: "tradeahv2.firebaseapp.com",
  projectId: "tradeahv2",
  storageBucket: "tradeahv2.firebasestorage.app",
  messagingSenderId: "398274404066",
  appId: "1:398274404066:web:74be764b202f62b91f08bb"
};

initializeApp(firebaseConfig);
const auth = getAuth();
const db = getFirestore();
const navigate = useNavigate;

export default function LoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigateTo = useNavigate();

const handleSubmit = async (e) => {
  e.preventDefault();
  setLoading(true);
  setError('');

  try {
    // 1. تسجيل الدخول بـ Firebase
    const userCredential = await signInWithEmailAndPassword(auth, email, password);
    const user = userCredential.user;
    const sessionId = userCredential.user.refreshToken; // ← ← ← معرف الجلسة الفريد

    // 2. التحقق من حالة الحساب
    const userDoc = await getDoc(doc(db, 'users', user.uid));
    if (userDoc.exists()) {
      const userData = userDoc.data();
      
      // إذا الحساب غير مفعل
      if (userData.trial_status !== 'active') {
        setError('حسابك غير مفعل بعد. يرجى الانتظار حتى يتم تفعيله من قبل الدعم.');
        await auth.signOut();
        setLoading(false);
        return;
      }

      // 3. ✅ التحقق من جلسة نشطة سابقة
      const sessionDoc = await getDoc(doc(db, 'user_sessions', user.uid));
      
      if (sessionDoc.exists()) {
        const activeSession = sessionDoc.data().active_session_id;
        
        // إذا كانت هناك جلسة نشطة من جهاز آخر
        if (activeSession && activeSession !== sessionId) {
          setError('تم تسجيل الدخول من جهاز آخر. سيتم تسجيل خروجك من الجهاز السابق.');
          
          // تسجيل خروج من الجهاز السابق (اختياري)
          // يمكنك هنا إرسال طلب لإنهاء الجلسة القديمة
        }
      }

      // 4. ✅ تحديث جلسة المستخدم الحالية
      await setDoc(doc(db, 'user_sessions', user.uid), {
        active_session_id: sessionId,
        last_activity: new Date().toISOString(),
        device_info: navigator.userAgent,
        user_email: email
      }, { merge: true });

      // 5. التوجيه للداشبورد
      navigateTo('/');
      
    } else {
      setError('لا يوجد حساب مرتبط بهذا البريد.');
      await auth.signOut();
    }

  } catch (err) {
    console.error(err);
    if (err.code === 'auth/invalid-credential' || err.code === 'auth/user-not-found') {
      setError('البريد الإلكتروني أو كلمة المرور غير صحيحة');
    } else if (err.code === 'auth/too-many-requests') {
      setError('تم حظر محاولات الدخول مؤقتًا. حاول لاحقًا.');
    } else {
      setError('حدث خطأ أثناء تسجيل الدخول');
    }
  } finally {
    setLoading(false);
  }
};

  return (
    <div 
      dir="ltr"
      style={{ 
        minHeight: '100vh', 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center',
        backgroundColor: '#f8fafc'
      }}
    >
      <div 
        style={{ 
          backgroundColor: 'white', 
          padding: '40px', 
          borderRadius: '20px', 
          boxShadow: '0 10px 25px rgba(0,0,0,0.1)',
          maxWidth: '450px',
          width: '100%'
        }}
      >
        <div style={{ textAlign: 'center', marginBottom: '24px' }}>
          <div style={{ 
            fontSize: '36px', 
            fontWeight: 'bold', 
            color: '#1e40af',
            marginBottom: '8px'
          }}>
            TradeAH
          </div>
          <div style={{ color: '#64748b' }}>
            سجّل دخولك لحسابك
          </div>
        </div>

        {error && (
          <div 
            style={{ 
              backgroundColor: '#fee', 
              color: '#c53030', 
              padding: '12px', 
              borderRadius: '8px', 
              marginBottom: '20px',
              fontSize: '14px'
            }}
          >
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: '20px' }}>
            <label 
              style={{ 
                display: 'block', 
                marginBottom: '8px', 
                fontWeight: '500', 
                color: '#1e293b' 
              }}
            >
              البريد الإلكتروني
            </label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="أدخل بريدك الإلكتروني"
              required
              style={{
                width: '100%',
                padding: '12px',
                border: '1px solid #e2e8f0',
                borderRadius: '10px',
                fontSize: '16px',
                backgroundColor: '#f8fafc'
              }}
            />
          </div>

          <div style={{ marginBottom: '24px' }}>
            <label 
              style={{ 
                display: 'block', 
                marginBottom: '8px', 
                fontWeight: '500', 
                color: '#1e293b' 
              }}
            >
              كلمة المرور
            </label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="أدخل كلمة المرور"
              required
              style={{
                width: '100%',
                padding: '12px',
                border: '1px solid #e2e8f0',
                borderRadius: '10px',
                fontSize: '16px',
                backgroundColor: '#f8fafc'
              }}
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            style={{
              width: '100%',
              padding: '14px',
              backgroundColor: loading ? '#94a3b8' : '#1e40af',
              color: 'white',
              border: 'none',
              borderRadius: '10px',
              fontSize: '16px',
              fontWeight: 'bold',
              cursor: loading ? 'not-allowed' : 'pointer',
              transition: 'background-color 0.2s'
            }}
          >
            {loading ? 'جاري الدخول...' : 'تسجيل الدخول'}
          </button>
        </form>
<div style={{ marginTop: '24px', textAlign: 'center' }}>
  <div style={{ fontSize: '14px', color: '#64748b', marginBottom: '12px' }}>
    ليس لديك حساب؟
   </div>
    <a 
      href="/signup"
      style={{
      backgroundColor: '#3b82f6',
      color: 'white',
      textDecoration: 'none',
      padding: '10px 24px',
      borderRadius: '8px',
      fontWeight: 'bold',
      display: 'inline-block'
             }}
             >
             تسجيل كعميل جديد
            </a>
           </div>
        <div style={{ marginTop: '24px', textAlign: 'center', fontSize: '14px', color: '#64748b' }}>
          <div>© {new Date().getFullYear()} TradeAH — جميع الحقوق محفوظة</div>
        </div>
      </div>
    </div>
  );
}